export default {
  line_items: [
    {
      lead_times: [1, 2, 3, 4, 5],
      pricing: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [5, 10, 20, 40],
      product_key: null,
      quote_config_key: null,
    },
  ],
};
